<template>
  <div v-if="filteredCartRecs.length" class="cart__recs">
    <h3 v-if="items.length">Customers also bought</h3>
    <h3 v-else>Products you may like</h3>
    <div class="cart__recs-items">
      <div 
        v-for="(recs,index) in filteredCartRecs" 
        :key="recs.id"
        class="cart__recs-item"
      >
        <a :href="recs.link" class="cart__recs-item-inner">
          <ImageField class="cart__recs-item-image" :obj="{'url':recs.image.src,'alt':recs.image.alt,'width':1000,'height': 1000}" width-param="width" sizes="291px"/>
          <div class="cart__recs-item-info">
            <span class="cart__recs-item-title">{{ recs.title }}</span>
            <span class="cart__recs-item-variant-title">{{ recVariantTitle(recs) }}</span>
            <div class="cart__recs-item-price">
              <span>{{ formatPrice(recFirstOneTimeVariant(recs).price) }}</span>
              <span v-if="recFirstOneTimeVariant(recs).price < recFirstOneTimeVariant(recs).compare_at_price"><s>{{ formatPrice(recFirstOneTimeVariant(recs).compare_at_price) }}</s></span>
            </div>

          </div>      
        </a>
        <button @click="addRecToCart(recFirstOneTimeVariant(recs).id)" class="btn btn--primary btn--xxs" type="button" aria-label="Add product to cart">Add</button>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, computed, toRefs } from 'vue';
  import ImageField from '../../global/image.vue';
  import {useStore} from "vuex";

  const props = defineProps({
    cartRecs: {
      type: Array,
      default: []
    },

    items: {
      type: Array,
      default: []
    }
  })

  const { cartRecs, items } = toRefs(props);
  const store = useStore();

  const filteredCartRecs = computed(() => {
    return cartRecs.value.filter(rec => !items.value.some(item => item.product_id === rec.id))
  })

  const recVariantTitle = (item) => {
    const variant = recFirstOneTimeVariant(item);

    if (item.type === "Merchandise" || variant.title === "Default Title") {
      return "";
    }

    let title = variant.title;

    if (variant.option1 === "Unflavored") {
      title = variant.option2;
    }

    // Replace numbers with "serving" or "servings" where appropriate
    title = title.replace(/\b(\d+)\b(?!\s*(Tub|Tubs|Bottle|Bottles|Box|Boxes))/g, (match, p1) => {
      return p1 === "1" ? `${p1} Serving` : `${p1} Servings`;
    });

    // Remove " / One Time Purchase" or " | One Time Purchase"
    title = title.replace(/ \/\s*One Time Purchase$| \|\s*One Time Purchase$/, '');

    return title;
  }

  const recFirstOneTimeVariant = (rec) => {
    if (rec.options[2] && ["Tubs", "Bottles", "Boxes"].includes(rec.options[2].name)) {
      return rec.variants.find(variant => variant.option3 === "One Time Purchase") || rec.variants[0];
    }
    return rec.variants[0];
  }

  const addRecToCart = (id) => {
    store.dispatch("add", {
      id: id,
      quantity: 1
    })
  }

  const formatPrice = (price) => {
    return window.formattedPrice(price);
  }
</script>